import type { PageComponentProps } from '@/features/a-dynamic-page/components/page-component-switch';
import type { PlaceHeaderV1Attributes } from '@/features/place-header/place-header-v1-type';

import { Badges, IconImage } from '@/core/features';

export type PlaceHeaderV1Props = PageComponentProps<PlaceHeaderV1Attributes>;

export default function PlaceHeaderV1({
    attributes,
    groupComponentProps = { isFullWidth: false, isLastGroupItem: false },
}: PlaceHeaderV1Props) {
    const { badges, placeIcon, subTitle, title } = attributes;
    const { isFullWidth } = groupComponentProps;
    return (
        <div className={'full-width shadow-bottom'}>
            <div
                className={`flex-space-between-horizontal padding-bottom-16 align-start ${isFullWidth ? 'padding-left-16 padding-right-16' : ''}`}
            >
                <div className={'flex-column line-height-22 font-size-18 gap-8'}>
                    <div className={'flex-column gap-4'}>
                        <h1 className={'font-size-18 bold hyphens-auto'}>{title}</h1>
                        {subTitle && <h2>{subTitle}</h2>}
                    </div>
                    {badges.length > 0 && (
                        <div className={'flex-start-center'}>
                            <Badges
                                badges={badges}
                                fontSize={14}
                                type={'horizontal'}
                                wrap={'wrap'}
                            />
                        </div>
                    )}
                </div>
                {placeIcon && (
                    <div>
                        <IconImage
                            height={32}
                            url={placeIcon}
                            width={32}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
